var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',[(!_vm.activeItem)?_c('div',{staticClass:"section"},[_c('loader')],1):_vm._e(),_vm._v(" "),(_vm.activeItem)?_c('id-check-form',{attrs:{"client":_vm.activeItem,"cta":"Order ID Checks"}}):_vm._e()],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v("Order ID Checks")])])
}]

export { render, staticRenderFns }